import { render, staticRenderFns } from "./MultiQuestionPartial.vue?vue&type=template&id=35e4ce12&scoped=true&"
import script from "./MultiQuestionPartial.vue?vue&type=script&lang=js&"
export * from "./MultiQuestionPartial.vue?vue&type=script&lang=js&"
import style0 from "./MultiQuestionPartial.vue?vue&type=style&index=0&id=35e4ce12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4ce12",
  null
  
)

export default component.exports